export const TRANSLATIONS_FR_HOME_ACTIONS_AND_OVERVIEW = {
  "home.title": "Système de génération augmentée par récupération",
  "home.lead":
    "Améliorez les réponses des modèles de langage avec des informations contextuelles issues de vos documents.",
  "home.description":
    "Téléversez des documents, faites des requêtes et obtenez des réponses précises basées sur vos propres informations.",
  "home.upload_btn": "Téléverser des documents",
  "home.query_btn": "Faire une requête",
  "home.feature_processing_title": "Traitement des documents",
  "home.feature_processing_desc":
    "Extrayez du texte de documents PDF, Word et TXT stockés sur S3 ou téléversés directement.",
  "home.feature_embeddings_title": "Embeddings et vectorisation",
  "home.feature_embeddings_desc":
    "Convertissez du texte en vecteurs à l'aide de modèles avancés pour la recherche sémantique.",
  "home.feature_generation_title": "Génération de réponses",
  "home.feature_generation_desc":
    "Obtenez des réponses précises basées sur vos documents à l'aide de modèles de langage avancés.",
  "home.general.loading": "Chargement de la télémétrie...",
  "home.general.retry": "Réessayer",
  "home.general.retryAfter": "Nouvel essai dans",
  "home.general.actionUnavailableTitle": "Action indisponible",
  "home.general.actionUnavailableMessage": "Nous n'avons pas assez d'informations pour terminer cette action.",
  "home.pagination.previous": "Précédent",
  "home.pagination.next": "Suivant",
  "home.shared.aiBadge": "Signal généré par l'IA",
  "home.shared.detectedBadge": "Détecté automatiquement",
  "home.shared.prioritizedBadge": "Priorisé par l'IA",
  "home.shared.recommendationBadge": "Étape recommandée",
  "home.reasonCode.due_soon": "Échéance proche",
  "home.reasonCode.overdue": "En retard",
  "home.reasonCode.high_priority": "Priorité élevée",
  "home.reasonCode.compliance_required": "Conformité requise",
  "home.reasonCode.needs_review": "À revoir",
  "home.reasonCode.pending_review": "En attente de revue",
  "home.decisionStates.act_now": "Agir maintenant",
  "home.decisionStates.act_soon": "Agir bientôt",
  "home.decisionStates.act_without_rush": "Peut attendre",
  "home.decisionStates.waiting": "Action planifiée",
  "home.decisionStates.blocked": "En attente d'informations",
  "home.decisionStates.in_review": "En revue",
  "home.decisionStates.dismissed": "Écartée",
  "home.decisionStates.safe_to_ignore": "Peut être ignorée",
  "home.decisionStates.completed": "Résolue",
  "home.attention.sectionTitle": "Requiert votre attention",
  "home.attention.followUpTitle": "Suivi",
  "home.attention.allClearTitle": "Tout est en ordre",
  "home.attention.allClearCopy": "Aucune décision ne requiert votre attention pour le moment.",
  "home.decisionDisplay.priority.critical.label": "Critique",
  "home.decisionDisplay.priority.critical.copy": "Elle est en retard ou peut créer un impact opérationnel.",
  "home.decisionDisplay.priority.high.label": "Haute",
  "home.decisionDisplay.priority.high.copy": "L'échéance est proche et nécessite une revue.",
  "home.decisionDisplay.priority.medium.label": "Moyenne",
  "home.decisionDisplay.priority.medium.copy": "Il faut la revoir bientôt pour éviter blocages ou retards.",
  "home.decisionDisplay.priority.low.label": "Basse",
  "home.decisionDisplay.priority.low.copy": "Elle peut rester sous surveillance pour l'instant.",
  "home.decisionDisplay.risk.critical.label": "Risque critique",
  "home.decisionDisplay.risk.critical.copy": "Il peut interrompre une opération importante ou provoquer une non-conformité immédiate.",
  "home.decisionDisplay.risk.high.label": "Risque élevé",
  "home.decisionDisplay.risk.high.copy": "Il peut affecter les paiements, la conformité ou la continuité opérationnelle.",
  "home.decisionDisplay.risk.medium.label": "Risque moyen",
  "home.decisionDisplay.risk.medium.copy": "Il peut créer des retards, du retraitement ou un suivi supplémentaire.",
  "home.decisionDisplay.risk.low.label": "Risque faible",
  "home.decisionDisplay.risk.low.copy": "L'impact opérationnel reste limité si la revue est faite à temps.",
  "home.decisionDisplay.risk.none.label": "Risque à confirmer",
  "home.decisionDisplay.risk.none.copy": "Le contexte est encore insuffisant pour qualifier le risque.",
  "home.decisionDisplay.confidence.high.label": "Confiance élevée",
  "home.decisionDisplay.confidence.high.copy": "La recommandation est cohérente avec les preuves disponibles.",
  "home.decisionDisplay.confidence.medium.label": "Confiance moyenne",
  "home.decisionDisplay.confidence.medium.copy": "Il vaut mieux revoir les preuves clés avant de confirmer.",
  "home.decisionDisplay.confidence.low.label": "Faible confiance",
  "home.decisionDisplay.confidence.low.copy": "Revoyez les preuves avant d'agir.",
  "home.decisionSummary.eyebrow": "États",
  "home.decisionSummary.title": "Résumé des décisions",
  "home.decisionList.eyebrow": "Boîte de réception",
  "home.decisionList.title": "Liste compacte des décisions",
  "home.decisionList.filteredTitle": "Décisions filtrées",
  "home.decisionList.empty": "Aucune décision à afficher pour l'instant.",
  "home.decisionList.emptyFiltered": "Aucune décision dans cet état.",
  "home.viewMode.current": "Vue actuelle",
  "home.viewMode.calendar": "Calendrier",
  "home.decisionActionForm.title": "Données requises",
  "home.decisionActionForm.selectPlaceholder": "Sélectionnez une option",
  "home.decisionActionForm.required": "Complétez ce champ pour continuer.",
  "home.decisionActionForm.confirmExecution": "Je confirme que cette action opérationnelle doit être exécutée.",
  "home.decisionActionForm.confirmRequired": "Confirmez l'action avant de continuer.",
  "home.decisionActionForm.submit": "Exécuter l'action",
  "home.decisionActionForm.cancel": "Annuler",
  "home.decisionActionUx.blockedCopy": "Cette décision est importante maintenant, mais elle ne peut pas être finalisée tant que le blocage n'est pas résolu.",
  "home.decisionActionUx.blockedReason": "Résolvez le blocage avant d'exécuter l'action finale.",
  "home.decisionActionUx.blockedTitle": "Urgent, mais bloqué",
  "home.decisionActionUx.catalogCopy": "La source de la décision n'est pas assez stable pour exécuter l'action finale.",
  "home.decisionActionUx.catalogReason": "La recommandation s'est dégradée et nécessite une revue manuelle.",
  "home.decisionActionUx.catalogTitle": "La recommandation doit être validée",
  "home.decisionActionUx.completeMissingInfo": "Vérifier les informations manquantes",
  "home.decisionActionUx.completedCopy": "Il n'y a aucune action en attente pour cette décision.",
  "home.decisionActionUx.completedReason": "Cette décision a déjà été résolue.",
  "home.decisionActionUx.completedTitle": "Décision résolue",
  "home.decisionActionUx.confirmRequiredData": "Confirmer les données requises",
  "home.decisionActionUx.disabledCopy": "Cette décision nécessite une revue avant de pouvoir réactiver l'action principale.",
  "home.decisionActionUx.disabledTitle": "L'action n'est pas disponible",
  "home.decisionActionUx.lowConfidenceCopy": "La décision ne doit pas être exécutée tant que les preuves et le niveau de confiance n'ont pas été vérifiés.",
  "home.decisionActionUx.lowConfidenceReason": "La confiance est trop faible pour exécuter l'action finale.",
  "home.decisionActionUx.lowConfidenceTitle": "Cette recommandation doit être vérifiée",
  "home.decisionActionUx.missingInfoCopy": "Vérifiez les informations manquantes dans ce panneau et complétez la donnée dans le document ou le système source avant de réessayer l'action.",
  "home.decisionActionUx.missingInfoReason": "L'action finale reste bloquée tant que cette donnée n'existe pas dans la source.",
  "home.decisionActionUx.missingInfoTitle": "Il manque des informations requises",
  "home.decisionActionUx.noActionCopy": "Il n'y a pas encore d'action confirmée pour cette décision.",
  "home.decisionActionUx.noActionTitle": "Aucune action confirmée",
  "home.decisionActionUx.readyCopy": "Cette décision est prête pour sa prochaine action.",
  "home.decisionActionUx.readyTitle": "Vous pouvez agir maintenant",
  "home.decisionActionUx.resolveBlock": "Voir le blocage",
  "home.decisionActionUx.reviewEvidence": "Vérifier les preuves",
  "home.decisionActionUx.reviewRecommendation": "Vérifier la recommandation",
  "home.decisionActionUx.reviewRequirements": "Vérifier les prérequis",
  "home.decisionActionUx.safeToIgnoreCopy": "Vous pouvez garder cette décision sous observation sans intervenir.",
  "home.decisionActionUx.safeToIgnoreReason": "Cette décision peut rester sous surveillance sans action immédiate.",
  "home.decisionActionUx.safeToIgnoreTitle": "Aucune action requise pour l'instant",
  "home.decisionActionUx.waitingCopy": "Cette décision dépend d'un signal externe ou d'une mise à jour en attente.",
  "home.decisionActionUx.waitingLabel": "Attendre la mise à jour",
  "home.decisionActionUx.waitingReason": "Home IA attend encore la condition qui active cette action.",
  "home.decisionActionUx.waitingTitle": "Vous ne pouvez pas encore agir",
};
